"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dfyn = void 0;
exports.dfyn = {
    router: "0xA102072A4C07F06EC3B4900FDC4C7B80b6c57429",
};
